function displayUSABanner() {
    var currencyDropdown = document.querySelector("#se-currency-form_inner select.currency-input");
    if (!currencyDropdown) {
        console.log("Currency dropdown not found.");
        return;
    }

    var currentCurrency = currencyDropdown.value;

    if (currentCurrency === 'USD') {
        var toshowifUSD = document.querySelectorAll('.showifUSD');
         if (toshowifUSD.length > 0) {
            toshowifUSD.forEach(function(nowshowifUSD) {
                nowshowifUSD.style.display = 'block';
            });
            console.log('USD-specific notices are displayed.');
        } else {
            console.log('No USD-specific notice elements found.');
        }
    } else {
        console.log('Currency is not USD.');
    }
}

// Run function on page load
window.addEventListener('load', displayUSABanner);